import { config } from '../config/config';

export const getImageUrl = (filenameOrUrl, forList = false) => {
    const value = String(filenameOrUrl ?? '').trim();
    if (/^https?:\/\//i.test(value)) {
        return value;
    }
    return `${config.uploadsUrl}/images/${value.substring(0, 3)}/${forList ? 'list_' : ''}${value}`;
};